
import { DollarSign, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Investment } from "@/types/investment";
import { usePrintAmortization } from "@/hooks/usePrintAmortization";

interface InvestmentActionButtonsProps {
  investment: Investment;
  onSubmitBid: () => void;
}

const InvestmentActionButtons = ({ investment, onSubmitBid }: InvestmentActionButtonsProps) => {
  const { printAmortizationSchedule } = usePrintAmortization();

  const handlePrintAmortization = () => {
    printAmortizationSchedule(investment);
  };

  return (
    <div className="mt-8 flex justify-center space-x-4">
      {investment.status === "Open for Bidding" && (
        <Button size="lg" className="bg-yellow-800 hover:bg-yellow-900" onClick={onSubmitBid}>
          <DollarSign className="h-5 w-5 mr-2" />
          Submit Investment Bid
        </Button>
      )}
      <Button 
        variant="outline" 
        size="lg"
        onClick={handlePrintAmortization}
        className="animate-pulse border-2 border-blue-500 text-blue-600 hover:bg-blue-50"
      >
        <Printer className="h-5 w-5 mr-2" />
        Print Amortization Schedule
      </Button>
    </div>
  );
};

export default InvestmentActionButtons;
